export const PLAYER_DEFAULT_STATION_ID: StationId = "mix1";
export const PLAYER_DEFAULT_BITRATE_FREE: Bitrate = "audio-mp4-aac-128k";
export const PLAYER_DEFAULT_BITRATE_PREMIUM: Bitrate = "audio-mp4-aac-128k";
export const PLAYER_DEFAULT_STREAM_FORMAT: StreamFormat = "pls";

export const BITRATE_OPTIONS: ReadonlyArray<JGOption<Bitrate>> = [
  { label: "128k AAC (Good)", value: "audio-mp4-aac-128k" },
  { label: "256k AAC (Great)", value: "audio-mp4-aac-256k" },
  { label: "FLAC (Best)", value: "audio-mp4-flac" },
];

export const STREAM_FORMAT_OPTIONS: ReadonlyArray<JGOption<StreamFormat>> = [
  { label: "PLS", value: "pls" },
  { label: "Stream URL", value: "stream" },
];

export const EXPANDED_STREAM_PATHS: Readonly<
  Record<StationId, Record<Bitrate, string>>
> = Object.freeze({
  mix1: Object.freeze({
    "audio-mp4-aac-64k": "345aae79-f44c-44fd-b122-8401ccf57872",
    "audio-mp4-aac-128k": "6441db21-9a8e-4745-af4d-ab0251c5312e",
    "audio-mp4-aac-256k": "0fc134ba-991c-4b1f-9b06-7e0358f1d680",
    "audio-mp4-flac": "d0105650-c51c-4842-ae39-f97b329acd2a",
  }),
  mix2: Object.freeze({
    "audio-mp4-aac-64k": "edbf84c2-5e3a-476e-ab3d-7ee5953ef6e7",
    "audio-mp4-aac-128k": "05de889c-5678-4a40-a36d-177e9ead2aa9",
    "audio-mp4-aac-256k": "aee9d7d1-9cf1-4db6-bb1c-808f95a17283",
    "audio-mp4-flac": "4482dfb3-d502-42ef-8184-fc56b0f3ed44",
  }),
  dreams: Object.freeze({
    "audio-mp4-aac-64k": "6d5c3073-a65f-44df-8cb7-c84a376cf991",
    "audio-mp4-aac-128k": "6cced571-fcb1-4410-84af-1f93aa434809",
    "audio-mp4-aac-256k": "ede77312-b4b9-4d27-88a3-47b0898f845b",
    "audio-mp4-flac": "1769696b-ae90-417f-b007-584c1b6edef8",
  }),
  gems: Object.freeze({
    "audio-mp4-aac-64k": "351bc659-1163-4487-9299-a7d5fb2477ed",
    "audio-mp4-aac-128k": "e156218c-3d28-4a1c-a262-f0c1ece0baee",
    "audio-mp4-aac-256k": "dc897e41-4f53-4f52-a0a3-05a23c580647",
    "audio-mp4-flac": "71cb1023-3c47-4c06-847d-5b15a3ddefee",
  }),
  smooth: Object.freeze({
    "audio-mp4-aac-64k": "0c7b380f-c009-4bb8-8235-ce8663719de4",
    "audio-mp4-aac-128k": "629959c2-59c4-4a58-9d05-3df5e4da6c5f",
    "audio-mp4-aac-256k": "7ed7b90c-3668-4b40-a615-a00eb0fc78b0",
    "audio-mp4-flac": "1614c7bc-e84e-4f64-8d22-1226d17cd681",
  }),
  christmas: Object.freeze({
    "audio-mp4-aac-64k": "7690c4f7-29d4-418e-81b0-83257846fbd0",
    "audio-mp4-aac-128k": "6ebceca4-52a9-4587-8ad5-9e998e608b57",
    "audio-mp4-aac-256k": "d9723942-1fe9-4dc6-b9b0-991b7bc4d4d4",
    "audio-mp4-flac": "515cc885-9a58-45c9-9d81-64a896458777",
  }),
  jazzed: Object.freeze({
    "audio-mp4-aac-64k": "9a77b902-344e-4d02-847f-e8b2f2b3f5ee",
    "audio-mp4-aac-128k": "a6d1335b-7b11-46c5-bdc9-8d6a42f0962a",
    "audio-mp4-aac-256k": "d32db65b-65a3-4679-bb51-e4a6b5499c0c",
    "audio-mp4-flac": "6e4ab2e6-4606-48e1-9743-6e7f9dbb966e",
  }),
  demo: Object.freeze({
    "audio-mp4-aac-64k": "345aae79-f44c-44fd-b122-8401ccf57872",
    "audio-mp4-aac-128k": "6441db21-9a8e-4745-af4d-ab0251c5312e",
    "audio-mp4-aac-256k": "0fc134ba-991c-4b1f-9b06-7e0358f1d680",
    "audio-mp4-flac": "d0105650-c51c-4842-ae39-f97b329acd2a",
  }),
});
